/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2022, Zumper
 */

import { is404Error } from '@zcode/error-filters'
import { definitelyError } from '@zcode/nr-utils'
import { getPriceChange } from '@zcode/price-data'
import type { Dispatch, PriceChartData, PriceChartDataForRoom } from '@zcode/state-type'
import { logger } from '../../../logger'
import { setPriceDataRecentAverages, setPriceDataYOYChange } from '../actions/index'

export const processPriceData =
  (payloadData: PriceChartData | PriceChartDataForRoom[]) => (dispatch: Dispatch) => {
    try {
      const data = payloadData as PriceChartData
      const recentAverages = data.map?.((room) => {
        const seriesLength = room?.series?.length
        if (seriesLength) {
          return room.series[seriesLength - 1]?.y
        }
        return undefined
      })
      dispatch(setPriceDataRecentAverages(recentAverages))

      const YOYChange = getPriceChange(data?.[1]?.series)
      dispatch(setPriceDataYOYChange(YOYChange))
    } catch (error) {
      if (!is404Error(error)) {
        const message = 'Failed to process price data'
        logger.error(message, definitelyError(message, error))
      }
    }
  }
